(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_eh-help-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ehHelpChatBound) return;
    window.__ehHelpChatBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-eh-open-chat]');
      if (!btn) return;
      if (window.MimirBubbleV2 && typeof window.MimirBubbleV2.open === 'function') {
        e.preventDefault();
        window.MimirBubbleV2.open();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_eh-help-hours"] && !Shopify.designMode) return;
  try {
    (function () {
    var DN = ['', 'man', 'tir', 'ons', 'tor', 'fre', 'lør', 'søn'];
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function osloParts(d) {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Oslo', year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(d);
      var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
      return { y: +o.year, md: o.month + '-' + o.day, day: { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 }[o.weekday], min: (+o.hour % 24) * 60 + +o.minute };
    }
    function holidays(y) {
      var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
          h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
          mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
      var easter = Date.UTC(y, mo - 1, da), list = ['01-01', '05-01', '05-17', '12-25', '12-26'];
      [-3, -2, 0, 1, 39, 49, 50].forEach(function (o) { var t = new Date(easter + o * 864e5); list.push(pad(t.getUTCMonth() + 1) + '-' + pad(t.getUTCDate())); });
      return list;
    }
    function toMin(s) { var a = String(s).trim().replace('.', ':').split(':'); return (+a[0] || 0) * 60 + (+a[1] || 0); }
    function hh(s) { var a = String(s).trim().replace('.', ':').split(':'); return !a[1] || a[1] === '00' ? a[0] : a[0] + '.' + a[1]; }

    function update(root) {
      if (!root) return;
      var now = osloParts(new Date());
      var extra = (root.dataset.closed || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var isClosedDay = holidays(now.y).concat(extra).indexOf(now.md) > -1;

      root.querySelectorAll('[data-hours]').forEach(function (el) {
        var h = el.getAttribute('data-hours').split('|');
        var days = h[0].split('-'), d1 = +days[0], d2 = +(days[1] || days[0]);
        var dayTxt = d1 === d2 ? DN[d1] : DN[d1] + '–' + DN[d2];
        el.querySelector('[data-label]').textContent = '· ' + dayTxt.charAt(0).toUpperCase() + dayTxt.slice(1) + ' ' + hh(h[1]) + '–' + hh(h[2]);
        var inDays = d1 <= d2 ? (now.day >= d1 && now.day <= d2) : (now.day >= d1 || now.day <= d2);
        var open = !isClosedDay && inDays && now.min >= toMin(h[1]) && now.min < toMin(h[2]);
        el.classList.toggle('is-open', open);
        el.querySelector('[data-status]').textContent = open ? root.dataset.txtOpen : (isClosedDay ? root.dataset.txtClosedToday : root.dataset.txtClosed);
      });
    }

    function updateAll() { document.querySelectorAll('[data-eh-help-hours]').forEach(update); }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll);
    else updateAll();

    /* Theme editor: oppdater når seksjoner/blokker re-rendres */
    ['shopify:section:load', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(updateAll, 0); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
